import React from "react";

import { Box, Stack, Typography } from "@mui/material";
import { Checkbox } from "components/forms";
import { IFile, IFolderTemplate, IFormTemplate } from "store/types";

import { EntityType, FileType } from "../../../constants";
import { FileIcon } from "../File-icon/FileIcon";
import { useImportContext } from "./import-context";

interface IProps {
  item: IFile | IFormTemplate;
  subIndex: number;
  folder: IFolderTemplate;
}

export const FolderItem: React.FC<IProps> = ({ item, subIndex, folder }) => {
  const { isSelected, selectItem } = useImportContext();
  const isIFile = (item: IFile | IFormTemplate): item is IFile => {
    return "type" in item && Object.values(FileType).some((type) => type === item.type);
  };
  const checkboxValue = isSelected({ key: isIFile(item) ? "files" : "forms", id: item.id });

  return (
    <Stack direction="row" alignItems="center" sx={{ padding: "9px 0" }}>
      <Box sx={{ marginRight: `${subIndex * 25 + 37}px` }}>
        <Checkbox
          value={checkboxValue}
          size="small"
          name={item.id as any}
          variant="mark-square"
          onChange={() => {
            if (isIFile(item)) {
              selectItem({ key: "files", item: { id: item.id, parentId: folder.id } });
            } else {
              selectItem({ key: "forms", item: { id: item.id, parentId: folder.id } });
            }
          }}
        />
      </Box>
      <FileIcon style={{ fill: "#5D7782" }} type={isIFile(item) ? FileType.FILE : EntityType.FORM} />

      <Typography
        sx={{
          textOverflow: "ellipsis",
          overflow: "hidden",
          whiteSpace: "nowrap",
          width: "200px",
          marginLeft: "7px",
          color: "#173c4c"
        }}
      >
        {isIFile(item) ? item.name : item.title}
      </Typography>
    </Stack>
  );
};
